import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class RollNo extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			cls : '',
			section : '',
			_message : '',
			alertClass :'',
			posts : [],
			data : [],
			rollno : [],
			_redirect : false
		}
		
		this.rno = [];
		
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		// this.handleChange = this.handleChange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.emptyhandler=this.emptyhandler.bind(this);
		
	}
	
	emptyhandler(e){}
	
	onClick(e){
		
		document.getElementById("stcatform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	handleChange(item,id,index,e){	
		
		if(this.rno.length < 1)
			this.rno.push('{"id":'+id+', "rolno":'+e.target.value+'}');
		
		this.rno.map((obj,k) => {
			var tes = JSON.parse(obj);
			if (tes.id == id)
				tes.rolno = e.target.value;
			else
				this.rno.push('{"id":'+id+', "rolno":'+e.target.value+'}');
		});
		console.log(this.rno);
		// this.setState({rollno});
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();	
	
			PostData('student/rnoupdate',this.rno).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Roll number Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("rollform").reset();
					// $("#roll").hide();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		
	
	}
	
	/* handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('student/deletecategory',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Student Category Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Student Category',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	} */
	
	componentDidMount() {
		 
		this.getclass();
	}
	
	/** get Class **/
	getclass(){
		$("#showLoader").show();	
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();	
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/leave/editcategory/' + this.state.idd} />);

	}
	
	var items = this.state.posts;
	var sec = this.state.secs;
	
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();	
		$.get(GLOBAL.BASE_URL+'section/getsectsbyclass/'+fr,function(o){
			$("#showLoader").hide();	
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});
			
		},'json');
	
	});
	
	if(this.state.cls && this.state.section){
		$("#showLoader").show();	
		GetData('student/getstdbysecandcls/'+this.state.cls+'/'+this.state.section).then((result) => {
			$("#showLoader").hide();	
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	// $("#roll").hide(1000);
	
	/* $("#secs").change(function(){
		var sr = $(this).val();
		var fr = $("#clas").val();
		GetData('student/getstdbysecandcls/'+fr+'/'+sr).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
		$.get(GLOBAL.BASE_URL+'student/getstdbysecandcls/'+fr+'/'+sr,function(o){
			
			$("#roll").html('');
			$('#roll')
			$.each(o,function(key,value){			
				$('#roll')
					.append('<tr><td><input type="hidden" name="std_id[]" id="std_id" onChange={this.onChange} value="'+value.id+'"  />'+value.id+'</td><td>'+value.admissionno+'</td><td>'+value.stdname+'</td><td><input type="text" name="rollnum" onChange={this.onChange} value="'+value.rollno+'" /></td></tr>');
			});
		},'json');
		
	}); */
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<form action="" method="post" role="form" id="rollform" encType="multipart/form-data" onSubmit={this.onSubmit} >
			<Row>
			  <Col md="12">
				<Card>
					<CardHeader>
						<strong>Student Roll Number</strong>
					</CardHeader>
					<CardBody>
						<Row>
						 <Col md="12">
							<Row>
								<Col md="3">
								  <FormGroup>
									<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
									<select name="cls" onChange={this.onChange} className="form-control" id="clas" required> 
										<option value="">Select Class</option>
										{
											items.map(function (item) {
												return <option value={item.id }>{item.class}</option>;
											})
										}
									</select>
								  </FormGroup>
								</Col>
								<Col md="3">
								  <FormGroup>
									<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
									<select name="section" onChange={this.onChange} className="form-control" id="secs" required>
											
									</select>
								  </FormGroup>
								</Col>
							</Row>
						 </Col>
						</Row>
					</CardBody>
				</Card>
			  </Col>
			  <Col md="12">
			   <Card>
				<CardHeader>
					<strong>Enter Roll Number</strong>
				</CardHeader>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th>Admission No</th>
							<th>Student Name</th>
							<th>Roll Number</th>
						</tr>
					</thead>
					<tbody id="roll">
						{this.state.data.map((item,index) =>

							<tr key = {index}>
								<td>{item.id}</td>
								<td>{item.admissionno}</td>
								<td>{item.stdname}</td>
								<td><input type="text" name="rollno" value={this.state.rollno[index]} onChange={this.emptyhandler} onBlur={this.handleChange.bind(this,item,item.id,index)} /></td>
							</tr>
						)}
					</tbody>
				</Table>
				</CardBody>
				<CardFooter>
					<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Save</Button>
				</CardFooter>
			   </Card>
			  </Col>
			</Row>
			</form>
		</div>
	)
  }
}

export default RollNo;


// WEBPACK FOOTER //
// ./src/student/RollNo/RollNo.js